export const text =
`
I teach at Olympic College.
`
